import React from "react";
import BlogCard from "../components/BlogCard";

const Blog = () => {
	return (
		<div className="page-fit p-4">
			<h1 className="font-bold w-full text-2xl sm:text-3xl mb-5">
				Blog Articles
			</h1>
			<BlogCard />
			<BlogCard />
			<BlogCard />
			<BlogCard />
		</div>
	);
};

export default Blog;
